const NS = 'SiteSubheaderCourseAssessmentWidget';
const CLS = 'siteSubheaderCourseAssessmentWidget';
import * as moment from 'moment';
import 'moment-duration-format';

export class SiteSubheaderCourseAssessmentWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.initTimeElapsed();
		this.initAttemptedQuizzes();
	}

	initTimeElapsed() {
		this.$inputValue = $(`#courseAssessmentPage-timeElapsedInputValue`);
		if(this.$inputValue.length > 0 && _.isFinite(this.$inputValue.val())) {
			this.duration = this.$inputValue.val(); // In milliseconds
		}
		else {
			this.duration = 0; // In milliseconds
		}

		this.intervalTime = 1000; // Single Second
		this.$timeElapsed = this.$element.find(`#${CLS}-item-stat-value--time`);

		this.printTimeElapsed();

		setInterval(() => {
			this.duration += this.intervalTime;
			this.printTimeElapsed();
		}, this.intervalTime);
	}

	printTimeElapsed() {
		this.$timeElapsed.text(moment.duration(this.duration).format('d [days] hh:mm:ss', {
			trim: 'large',
			stopTrim: 'hh mm ss'
		}));

		if(this.$inputValue.length > 0) {
			this.$inputValue.val(this.duration);
		}
	}

	initAttemptedQuizzes() {
		this.attemptedQuestions = 0;
		this.totalQuestions = 0;
		this.$itemStatValueCurrent = this.$element.find(`.${CLS}-item-stat-value-current`);
		this.$itemStatValueTotal = this.$element.find(`.${CLS}-item-stat-value-total`);
		this.$progressBarWidget = this.$element.find(`.progressBarWidget`);

		let getPercentage = () => {
			if(this.totalQuestions > 0) {
				if(this.attemptedQuestions <= this.totalQuestions) {
					return Math.ceil((this.attemptedQuestions / this.totalQuestions) * 100);
				}
				else {
					console.error(`${NS}::Error`, 'Attempted questions is greater than the totalQuestions.');
				}
			}
			else {
				console.error(`${NS}::Error`, 'this.totalQuestions has a length of zero.');
			}
			return 0;
		};

		this.$element.on(`${CLS}.quizzes.init`, (event, params) => {
			if(!_.isNil(params.attemptedQuestions)) {
				this.attemptedQuestions = params.attemptedQuestions;
				this.$itemStatValueCurrent.html(params.attemptedQuestions);
			}
			else {
				this.$itemStatValueCurrent.html(this.attemptedQuestions);
			}

			if(!_.isNil(params.totalQuestions) && params.totalQuestions > 0) {
				this.totalQuestions = params.totalQuestions;
				this.$itemStatValueTotal.html(params.totalQuestions);
				this.$progressBarWidget.trigger('progressBarWidget.update', {
					percentage: getPercentage(),
					animate: false
				});
			}
			else {
				this.$itemStatValueTotal.html(this.totalQuestions);
			}
		});

		this.$element.on(`${CLS}.quizzes.increment`, (_event, _params) => {
			if(this.totalQuestions > 0) {
				this.attemptedQuestions++;
				this.$itemStatValueCurrent.html(this.attemptedQuestions);
				this.$progressBarWidget.trigger('progressBarWidget.update', {
					percentage: getPercentage()
				});
			}
			else {
				console.error(`${NS}::Error`, 'Could not increment the attempted questions.');
			}
		});
	}
}
